export const calculateTotalCosts = (values, setValue) => (data, keyName) => {
  setValue(keyName, data);

  const costType = keyName.split('.').pop();

  const total = values.reduce((a, b) => Number(a) + Number(b?.[costType] || 0), 0);

  setValue(`total_${costType}`, total);
};

export const reCalculateAllTotals = (setValue) => (data) => {
  const totals = {
    labor_cost: 0,
    material_cost: 0,
    equipment_cost: 0,
    subcontractor_cost: 0,
    other_cost: 0,
    overall_cost: 0,
  };

  data.forEach((item) => {
    totals.labor_cost += Number(item.labor_cost || 0);
    totals.material_cost += Number(item.material_cost || 0);
    totals.equipment_cost += Number(item.equipment_cost || 0);
    totals.subcontractor_cost += Number(item.subcontractor_cost || 0);
    totals.other_cost += Number(item.other_cost || 0);
    totals.overall_cost += Number(item.overall_cost || 0);
  });

  Object.keys(totals).forEach((key) => {
    setValue(`total_${key}`, totals[key]);
  });
};
